// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { OrderLineDetail } from './order-line-detail';
import { Part } from './part';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class PartBulkEdit extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get isProcessed() {
    return !!this.processed;
  }
  get isSent() {
    return !!this.sent;
  }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  created!: Date;
  createdBy?: string;
  orderLineDetailId!: number;
  partId!: number;
  processed?: Date;
  sent?: Date;
  orderLineDetail!: OrderLineDetail;
  part!: Part;
}

